import { isRoleAssignable } from '@aureus/donna-roles';

export const filterUsers = (users) => {
  return users.filter((user) => {
    const { userType } = user;
    return isRoleAssignable(userType) || userType === undefined;
  });
};
